import {
  NullableBooleanSetting,
  useUserSettingWithDefault,
} from "shared-ts-utils-user-settings";

export const useAnonymizeIssueMonitoringDataWithNullAsDefault = () => {
  return useUserSettingWithDefault<boolean | null>(
    "anonymizeIssueMonitoringData",
    NullableBooleanSetting,
    null
  );
};
